import { Outlet, redirect, useNavigation } from "react-router-dom";
import { getToken } from "./utils/token";
import instance from "./axios/instance";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useEffect } from "react";
import "react-phone-input-2/lib/style.css";

export const appLoader = async ({ request }) => {
  const token = getToken();
  const url = request.url;

  console.log(url);

  // If no token and trying to access protected route, redirect to login
  if (!token && !url.includes("/auth")) {
    return redirect("/auth/login");
  }

  // If on auth page and no token, allow access
  if (!token && url.includes("/auth")) {
    return "";
  }

  try {
    const res = await instance.get("/doctor", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const status = res.data.account_status;

    if (!url.includes("/dashboard") && status !== "deactivated") {
      return redirect("/dashboard/overview");
    }

    return "";
  } catch (error) {
    console.error(
      "Token verification failed:",
      error.response?.data?.message || error.message,
    );

    // If token is invalid and we're on a dashboard route, redirect to login
    if (url.includes("/dashboard")) {
      if (url.includes("vitalrx")) {
        return redirect("/auth/login-vitalrx");
      }
      return redirect("/auth/login");
    }
    return "";
  }
};

export default function App() {
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === "loading") {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [navigation.state]);

  return (
    <div className="font-body">
      <Outlet />
      <ToastContainer />
    </div>
  );
}
